/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { EntretienDto } from '../models/entretien-dto';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des entretiens
 */
@Injectable({
  providedIn: 'root',
})
export class EntretienService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation entretienGetList
   */
  static readonly EntretienGetListPath = '/api/entretiens/list';

  /**
   * Renvoie la liste des entretiens.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `entretienGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  entretienGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<EntretienDto>>> {

    const rb = new RequestBuilder(this.rootUrl, EntretienService.EntretienGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<EntretienDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des entretiens.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `entretienGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  entretienGetList(params?: {
  }): Observable<Array<EntretienDto>> {

    return this.entretienGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<EntretienDto>>) => r.body as Array<EntretienDto>)
    );
  }

  /**
   * Path part for operation entretienLoadList
   */
  static readonly EntretienLoadListPath = '/api/entretiens/load-list';

  /**
   * Renvoie la liste des entretiens (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `entretienLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  entretienLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, EntretienService.EntretienLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des entretiens (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `entretienLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  entretienLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.entretienLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation entretienGet
   */
  static readonly EntretienGetPath = '/api/entretiens/{id}';

  /**
   * Renvoie l'entretien spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `entretienGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  entretienGet$Response(params: {

    /**
     * Identifiant de l&#x27;entretien
     */
    id: number;
  }): Observable<StrictHttpResponse<EntretienDto>> {

    const rb = new RequestBuilder(this.rootUrl, EntretienService.EntretienGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EntretienDto>;
      })
    );
  }

  /**
   * Renvoie l'entretien spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `entretienGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  entretienGet(params: {

    /**
     * Identifiant de l&#x27;entretien
     */
    id: number;
  }): Observable<EntretienDto> {

    return this.entretienGet$Response(params).pipe(
      map((r: StrictHttpResponse<EntretienDto>) => r.body as EntretienDto)
    );
  }

  /**
   * Path part for operation entretienPut
   */
  static readonly EntretienPutPath = '/api/entretiens/{id}';

  /**
   * Met à jour l'entretien spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `entretienPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  entretienPut$Response(params: {

    /**
     * Identifiant de l&#x27;entretien à mettre à jour
     */
    id: number;

    /**
     * Entretien
     */
    body: EntretienDto
  }): Observable<StrictHttpResponse<EntretienDto>> {

    const rb = new RequestBuilder(this.rootUrl, EntretienService.EntretienPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EntretienDto>;
      })
    );
  }

  /**
   * Met à jour l'entretien spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `entretienPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  entretienPut(params: {

    /**
     * Identifiant de l&#x27;entretien à mettre à jour
     */
    id: number;

    /**
     * Entretien
     */
    body: EntretienDto
  }): Observable<EntretienDto> {

    return this.entretienPut$Response(params).pipe(
      map((r: StrictHttpResponse<EntretienDto>) => r.body as EntretienDto)
    );
  }

  /**
   * Path part for operation entretienDelete
   */
  static readonly EntretienDeletePath = '/api/entretiens/{id}';

  /**
   * Supprime l'entretien spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `entretienDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  entretienDelete$Response(params: {

    /**
     * Identifiant de l&#x27;entretien à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, EntretienService.EntretienDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime l'entretien spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `entretienDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  entretienDelete(params: {

    /**
     * Identifiant de l&#x27;entretien à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.entretienDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation entretienPost
   */
  static readonly EntretienPostPath = '/api/entretiens';

  /**
   * Crée l'entretien spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `entretienPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  entretienPost$Response(params: {

    /**
     * Entretien
     */
    body: EntretienDto
  }): Observable<StrictHttpResponse<EntretienDto>> {

    const rb = new RequestBuilder(this.rootUrl, EntretienService.EntretienPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EntretienDto>;
      })
    );
  }

  /**
   * Crée l'entretien spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `entretienPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  entretienPost(params: {

    /**
     * Entretien
     */
    body: EntretienDto
  }): Observable<EntretienDto> {

    return this.entretienPost$Response(params).pipe(
      map((r: StrictHttpResponse<EntretienDto>) => r.body as EntretienDto)
    );
  }

}
